// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#chatbot {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 9999;
}

/* styles.scss */
.chatbot {
  border-radius: 8px !important;
}
.chatbot p,
.chatbot textarea {
  font-size: 1.5rem !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/chatbot/chatbot.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;AACJ;;AACA,gBAAA;AACA;EACI,6BAAA;AAEJ;AADI;;EAEI,4BAAA;AAGR","sourcesContent":["#chatbot {\n    position: fixed;\n    bottom: 0;\n    right: 0;\n    z-index: 9999;\n}\n/* styles.scss */\n.chatbot {\n    border-radius: 8px !important;\n    p,\n    textarea {\n        font-size: 1.5rem !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
